import { useState, useEffect } from "react";
import FakeData from "./Components/FakeData/FakeData.json";
import Player from "./Components/Player/Player";
import "./App.css";
import Cart from "./Components/Cart/Cart";

function App() {
  const [players, setPlayers] = useState([]);
  useEffect(() => {
    setPlayers(FakeData);
  }, []);
  const [selectedPlayer, setSelectedPlayer] = useState([]);
  const handleAddPlayer = (player) => {
    let newPlayer = [...selectedPlayer, player];
    setSelectedPlayer(newPlayer);
  };
  let total = selectedPlayer.reduce((total, player) => total + player.money, 0);
  let granTotal = Math.round(total);
  console.log(granTotal);
  return (
    <div className="App d-flex mt-3">
      <div className="left-side">
        {players.map((player) => (
          <Player handleAddPlayer={handleAddPlayer} player={player}></Player>
        ))}
      </div>
      <div className="right-side">
        <h1 className="text-center">Total Player:{players.length}</h1>
        <h3 className="text-center">
          Total selected Players: {selectedPlayer.length}
        </h3>
        <h3 className="text-center">Total Salary: ${granTotal}</h3>
        {selectedPlayer.map((player) => (
          <Cart player={player}></Cart>
        ))}
      </div>
    </div>
  );
}

export default App;
